<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-6 col-lg-5">
        <div class="card shadow-sm">
          <div class="card-body p-4 p-md-5">
            <div class="text-center mb-4">
              <img src="@/assets/logo-main.webp" alt="Logo" style="height: 40px;" class="mb-3">
              <h3 class="card-title mb-3">Iniciar Sesión</h3>
            </div>
            <form @submit.prevent="handleLogin">
              <div class="mb-3">
                <label for="email" class="form-label">Correo Electrónico</label>
                <input type="email" class="form-control" id="email" v-model="email" required placeholder="tu@email.com">
              </div>
              <div class="mb-3">
                <label for="password" class="form-label">Contraseña</label>
                <input type="password" class="form-control" id="password" v-model="password" required placeholder="********">
              </div>
              <div class="d-grid mb-3">
                <button type="submit" class="btn btn-primary">Ingresar</button>
              </div>
              <div class="text-center">
                <small class="text-muted">¿No tienes cuenta? <router-link to="/signup">Regístrate aquí</router-link></small>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginView',
  data() {
    return {
      email: '',
      password: ''
    };
  },
  methods: {
    handleLogin() {
      // Lógica de inicio de sesión aquí
      console.log('Login attempt:', this.email);
      // Aquí iría la llamada a la API, etc.
      // Por ahora, redirigir a la home como ejemplo
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>
/* Estilos adicionales si son necesarios */
.card {
  border: none;
}
</style>
